import { useState } from 'react';
import { useGetOldPassword, useUpdatePassword } from "@/hooks/useAuth";
import { useAuth } from "@/_zustand/auth";
import bcrypt from "bcryptjs-react";
import toast from "react-hot-toast";
import { validateNewPassword } from "@/lib/passwordPolicy";
import { PasswordRequirements } from "@/components/PasswordRequirements";

export const PasswordForm = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  
  const {
    mutate: updatePasswordMutate,
    isLoading: isUpdating,
  } = useUpdatePassword();

  const {
    mutateAsync: getOldPasswordMutateAsync,
    isLoading: isGettingOldPassword,
  } = useGetOldPassword();

  const { user } = useAuth();

  const handleClick = async () => {
    if (!currentPassword) {
      toast.error("Debe ingresar su contraseña actual.");
      return;
    }
    if (!newPassword) {
      toast.error("Debe ingresar una nueva contraseña.");
      return;
    }
    if (!newPassword2) {
      toast.error("Debe confirmar la nueva contraseña.");
      return;
    }
    if (newPassword2 !== newPassword) {
      toast.error("Las nuevas contraseñas no coinciden.");
      return;
    }

    // Validaciones de fortaleza (igual que app móvil)
    const validationError = validateNewPassword(newPassword);
    if (validationError) {
      toast.error(validationError);
      return;
    }

    try {
      const oldPasswordResponse = await getOldPasswordMutateAsync(user.usuario_id);
      const storedOldPasswordHash = oldPasswordResponse?.currentPassword;

      if (!storedOldPasswordHash) {
        toast.error("No se pudo obtener la contraseña actual para verificación.");
        return;
      }

      const isCurrentPasswordCorrect = bcrypt.compareSync(currentPassword, storedOldPasswordHash);
      if (!isCurrentPasswordCorrect) {
        toast.error("La contraseña actual es incorrecta.");
        return;
      }

      // Verificar que la nueva contraseña sea distinta a la actual
      const isSameAsOld = bcrypt.compareSync(newPassword, storedOldPasswordHash);
      if (isSameAsOld) {
        toast.error("La nueva contraseña no puede ser igual a la actual.");
        return;
      }

      const hashedPassword = bcrypt.hashSync(newPassword, 10);
      const passwordHashedForBackend = hashedPassword.replace(/^\$2b(.+)$/i, '$2y$1');

      const dataToSend = {
        usuario_id: user.usuario_id,
        usuario_passNew: passwordHashedForBackend,
      };

      await updatePasswordMutate(dataToSend);

      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");
   
    } catch (error) {
      console.error("-> handleClick: Error general en el proceso de actualización:", error);
    }
  };

  return (
    <div className="profile-form-section">
      <h2 className="profile-form-title">Contraseña</h2>
      <form className="profile-form">
        <div className="profile-form-row">
          <div>
            <label>Contraseña actual</label>
            <input
              type="password"
              placeholder="********"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              disabled={isUpdating || isGettingOldPassword}
            />
          </div>
          <div>
            <label>Nueva contraseña</label>
            <input
              type="password"
              placeholder="********"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={isUpdating || isGettingOldPassword}
            />
            <PasswordRequirements password={newPassword} />
          </div>
          <div>
            <label>Repetir nueva contraseña</label>
            <input
              type="password"
              placeholder="********"
              value={newPassword2}
              onChange={(e) => setNewPassword2(e.target.value)}
              disabled={isUpdating || isGettingOldPassword}
            />
          </div>
        </div>

        <button
          type="button"
          className="profile-update-button"
          onClick={handleClick}
          disabled={isUpdating || isGettingOldPassword}
        >
          {isUpdating || isGettingOldPassword ? 'Procesando...' : 'Actualizar datos'}
        </button>
      </form>
    </div>
  );
};